export default "__VITE_ASSET__DMTwacN8__"